<div *ngIf="!showRequest">
    <h2 *ngIf="isShow" class="sectionTitle">{{'ADMIN_USER.SmallUnits.Register_Measurment_FORM' | translate }}</h2>
  
    <div *ngIf="isLoaded && baseRequestId" class="read-only-content">
      <!--request Details summary-->
       <app-entrance-request #EntranceRequest [IsAdminMode]="true" [AgentId]="agentId" [RequestStatus]="requestStatus">
      </app-entrance-request>
    </div>
  
    <div *ngIf="baseRequestId" class="">
  
      <form [formGroup]="registerMeasurmentsForm">
  
        <fieldset [disabled]="formMode == FormMode.Readonly">
          <div class="form-container">
            <div class="form-section">
              <h4 class="section-title">{{'ADMIN_USER.SmallUnits.Register_Measurment_Title'| translate}}</h4>
              <div class="form-group">
                <label for="Decision">{{'FRONT_USER.REGISTER_ADMIN_DECISION_FORM.DECISION' | translate}}</label>
                  <span class="red">*</span>
                <div class="form-custom-inputs">
                  <div *ngFor="let decisions of decisionKeys;let i='index'" class=" custom-Radio">
                    <input type="radio" [id]=[decisions] (change)="changeDecision(decision[decisions])"  name="Decision" 
                    [value]="decision[decisions]" formControlName="Decision" />
  
                    <label [for]="[decisions]">{{ 'FRONT_USER.ADMIN_DECISION_FORM.' + decisions | translate }}</label>
                  </div>
                </div>
                <div *ngIf="submitted && f.Decision?.errors" class="red">
                  <div *ngIf="f.Decision?.errors?.required">{{'FRONT_USER.This_Field_Is_Required' | translate}}</div>
  
                </div>
              </div>
              <div *ngIf="decisionValue == decision.Reject" class="form-group">
                  
                <label
                  for="RejectReason">{{'FRONT_USER.REGISTER_ADMIN_DECISION_FORM.MORE_INFORMATION' | translate}}</label>
                <span class="red">*</span>
                <textarea formControlName="RejectReason" id="RejectReason" name="RejectReason"
                  class="form-control"
                  [ngClass]="{ 'is-invalid': submitted ||(f.RejectReason?.dirty && f.RejectReason?.errors) }"></textarea>
                <div *ngIf="submitted ||(f.RejectReason?.dirty && f.RejectReason?.errors)" class="red">
                  <div *ngIf="f.RejectReason?.errors?.required">
                    {{'FRONT_USER.This_Field_Is_Required' | translate}}
                  </div>
                </div>
  
              </div>
            </div>
          </div>
        </fieldset>
        <div class="form-container">  
            <div *ngIf="decisionValue == decision.Approve" class="form-section">
                <h4  class="section-title">{{'ADMIN_USER.SmallUnits.Register_Measurment_Measurments'| translate}}</h4>
                <div class="form-group">
                <label
                  for="Length">{{'ADMIN_USER.SmallUnits.Register_Measurment_Length' | translate}}</label>
                <span class="red">*</span>
                <input type="text" formControlName="Length" id="Length" name="Length"   class="form-control"/>
                <div *ngIf="submitted || (f.Length?.dirty &&f.Length?.errors)" class="red">
                    <div *ngIf="f.Length?.errors?.required">
                      {{'FRONT_USER.This_Field_Is_Required' | translate}}
                    </div>
                    <div *ngIf="f.Length?.errors?.pattern">
                          {{'FRONT_USER.NUMBER_ERROR' | translate}}
                    </div>
                </div>
                </div>
                <div class="form-group">
                    <label
                    for="Width">{{'ADMIN_USER.SmallUnits.Register_Measurment_Width' | translate}}</label>
                  <span class="red">*</span>
                  <input type="text" formControlName="Width" id="Width" name="Width"    class="form-control"/>
                  <div *ngIf="submitted || (f.Width?.dirty &&f.Width?.errors)" class="red">
                    <div *ngIf="f.Width?.errors?.required">
                      {{'FRONT_USER.This_Field_Is_Required' | translate}}
                    </div>
                    <div *ngIf="f.Width?.errors?.pattern">
                          {{'FRONT_USER.NUMBER_ERROR' | translate}}
                    </div>
                </div>
                </div>
                <div class="form-group">
                    <label
                    for="Hight">{{'ADMIN_USER.SmallUnits.Register_Measurment_Hight' | translate}}</label>
                  <span class="red">*</span>
                  <input type="text" formControlName="Hight" id="Hight" name="Hight"  class="form-control" />
                  <div *ngIf="submitted || (f.Hight?.dirty &&f.Hight?.errors)" class="red">
                    <div *ngIf="f.Hight?.errors?.required">
                      {{'FRONT_USER.This_Field_Is_Required' | translate}}
                    </div>
                    <div *ngIf="f.Hight?.errors?.pattern">
                          {{'FRONT_USER.NUMBER_ERROR' | translate}}
                    </div>
                </div>
                </div>
                <div class="form-group">
                    <label
                    for="SCNT">{{'ADMIN_USER.SmallUnits.Register_Measurment_SCNT' | translate}}</label>
                  <span class="red">*</span>
                  <input type="text" formControlName="SCNT" id="SCNT" name="SCNT" (change)="calculateTransitFees()"  class="form-control" />
                  <div *ngIf="submitted || (f.SCNT?.dirty &&f.SCNT?.errors)" class="red">
                    <div *ngIf="f.SCNT?.errors?.required">
                      {{'FRONT_USER.This_Field_Is_Required' | translate}}
                    </div>
                    <div *ngIf="f.SCNT?.errors?.pattern">
                          {{'FRONT_USER.NUMBER_ERROR' | translate}}
                    </div>
                    <div *ngIf="f.SCNT?.errors?.max">
                      {{'ADMIN_USER.SmallUnits.ESTIMATED_FEES_MAX_NET_TONNAGE' | translate}}
                    </div>
                </div>
                </div>
                <div class="form-group">
                    <label
                    for="SCGT">{{'ADMIN_USER.SmallUnits.Register_Measurment_SCGT' | translate}}</label>
                  <span class="red">*</span>
                  <input type="text" formControlName="SCGT" id="SCGT" name="SCGT"      class="form-control" />
                  <div *ngIf="submitted || (f.SCGT?.dirty &&f.SCGT?.errors)" class="red">
                    <div *ngIf="f.SCGT?.errors?.required">
                      {{'FRONT_USER.This_Field_Is_Required' | translate}}
                    </div>
                    <div *ngIf="f.SCGT?.errors?.pattern">
                          {{'FRONT_USER.NUMBER_ERROR' | translate}}
                    </div>
                    <div *ngIf="f.SCGT?.errors?.max">
                      {{'ADMIN_USER.SmallUnits.ESTIMATED_FEES_MAX_Gross_TONNAGE' | translate}}
                    </div>
                </div>
               </div>
               <!-- SDR Rate -->
               <div class="form-group">
                <label for="SDRRate">{{ 'FRONT_USER.FEES_ESTIMATION_FORM.SDR_RATE' | translate}}</label>
                <span class="red">*</span>
                <input type="text" formControlName="SDRRate" id="SDRRate" name="SDRRate" (change)="calculateTransitFees()" class="form-control" />
                <div *ngIf="submitted || (f.SDRRate?.dirty &&f.SDRRate?.errors)" class="red">
                  <div *ngIf="f.SDRRate?.errors?.required">
                    {{'FRONT_USER.This_Field_Is_Required' | translate}}
                  </div>
                  <div *ngIf="f.SDRRate?.errors?.pattern">
                        {{'FRONT_USER.NUMBER_ERROR' | translate}}
                      </div>
                </div>
              </div>
              <!-- SDR Date -->
              <div class="form-group">
                <label for="SDRDate">{{ 'FRONT_USER.FEES_ESTIMATION_FORM.SDR_DATE' | translate }}</label>
                <span class="red">*</span>
                  <input class="form-control" #datepickerYMD="bsDatepicker" bsDatepicker [minDate]="null" [maxDate]='todayDate' formControlName="SDRDate">
                <div *ngIf="submitted || (f.SDRDate?.dirty && f.SDRDate?.errors)" class="red ">
                  <div *ngIf="f.SDRRate?.errors?.required">{{'FRONT_USER.This_Field_Is_Required' | translate}}</div>
                  <div *ngIf="f.SDRDate?.errors?.inValidDateError">
                    {{'FRONT_USER.DATE_ERROR' | translate}}
                  </div>
                </div>
              </div>
              <!-- Local Equivalent -->
              <div class="form-group">
                <label for="LocalEquiv">{{ 'ADMIN_USER.SmallUnits.FINALFEES_LOCALEQUIV' | translate}}</label>
                <span class="red">*</span>
                <input type="text" formControlName="LocalEquiv" id="LocalEquiv" name="LocalEquiv" (change)="calculateTotalFeesLE()" class="form-control" />
                <div *ngIf="submitted || (f.LocalEquiv?.dirty &&f.LocalEquiv?.errors)" class="red">
                  <div *ngIf="f.LocalEquiv?.errors?.required">
                    {{'FRONT_USER.This_Field_Is_Required' | translate}}
                  </div>
                  <div *ngIf="f.LocalEquiv?.errors?.pattern">
                        {{'FRONT_USER.NUMBER_ERROR' | translate}}
                      </div>
                </div>
              </div>
              <!-- Auditor -->
              <div class="form-group">
                <label for="AuditorId">{{ 'FRONT_USER.FEES_ESTIMATION_FORM.AUDITOR' | translate}}</label>
                <span class="red">*</span>
                <select formControlName="AuditorId" class="form-control" id="AuditorId"
                    name="AuditorId">
                    <option [value]="''" selected>
                        {{'FRONT_USER.FEES_ESTIMATION_FORM.CHOOSE_AUDITOR' | translate}}</option>
                    <ng-container *ngFor="let auditor of AuditorsList">
                        <option [value]="auditor?.Username">
                            {{auditor?.Username}}
                        </option>
                    </ng-container>
                </select>
                <div *ngIf="submitted || (f.AuditorId?.dirty &&f.AuditorId?.errors)" class="red">
                  <div *ngIf="f.AuditorId?.errors?.required">
                    {{'FRONT_USER.This_Field_Is_Required' | translate}}
                  </div>
                </div>
            </div>

              </div>
            <div *ngIf="formMode == FormMode.Add" class="form-group">
          <button Confirmation (confirmationClick)="onSubmit()"
            class="btn btn-primary SCAcustomBtn">{{ 'FRONT_USER.SUBMIT' | translate}}</button>
           </div> 
        </div>

       
      </form>
  
      <br>
  
    </div>
  </div>
  
  <!-- Confirmation -->
  <div *ngIf="showRequest && !isErrorMessage  && !lockTaskErrorMessage" class="alert alert-success" role="alert">
    <div class="alignC">
      <svg version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 300 300" xml:space="preserve"
        xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <g>
          <g>
            <path
              d="M150,0C67.157,0,0,67.157,0,150s67.157,150,150,150s150-67.157,150-150S232.843,0,150,0z M223.413,128.844l-76.696,69.434    c-1.88,1.704-4.072,2.85-6.367,3.452c-1.979,0.882-4.103,1.338-6.235,1.338c-3.794,0-7.594-1.398-10.566-4.217l-47.222-44.826    c-6.147-5.836-6.398-15.549-0.563-21.696c5.83-6.147,15.546-6.401,21.696-0.565l37.587,35.678l67.764-61.355    c6.282-5.688,15.987-5.208,21.675,1.076C230.174,113.448,229.694,123.153,223.413,128.844z">
            </path>
          </g>
        </g>
      </svg>
      <p>{{ 'FRONT_USER.REGISTER_ADMIN_DECISION_FORM.TAKE_DECISION_SUCCESS_MESSAGE' | translate }}</p>
      <hr>
      <p>{{ 'FRONT_USER.GOBACK' | translate }} <a routerLink="/workspace">
          {{ 'FRONT_USER.WORKSPACE.MY_WORKSPACE' | translate }}</a></p>
  
    </div>
  </div>
  
  <!-- error message -->
  <div *ngIf="showRequest && isErrorMessage" class="alert alert-danger" role="alert">
    <div class="alignC">
      <i class="icon-error"></i>
  
      <p>{{'FRONT_USER.ERRORS_MESSAGES.EROOR_MESSAGE' | translate}}</p>
      <hr>
      <p>{{ 'FRONT_USER.GOBACK' | translate }} <a routerLink="/workspace">
          {{ 'FRONT_USER.WORKSPACE.MY_WORKSPACE' | translate }}</a></p>
    </div>
  </div>
  
  <div *ngIf="showRequest && lockTaskErrorMessage" class="alert alert-warning" role="alert">
      <div class="alignC">
          <i class="icon-error"></i>
          <p>{{'FRONT_USER.ERRORS_MESSAGES.LOCK_TASK_ERROR_MESSAGE' | translate}}</p>
          <hr>
          <p>{{ 'FRONT_USER.GOBACK' | translate }} <a routerLink="/workspace">
            {{ 'FRONT_USER.WORKSPACE.MY_WORKSPACE' | translate }}</a></p>
        </div>
    </div>
  